export default "__VITE_ASSET__m0P4Yj54__"